import { Injectable } from '@angular/core';

import { WindowService } from './window.service';

@Injectable()
export class PageService {

  constructor(private _window: WindowService) { }

  private getDocument() {
    return this
      ._window
      .nativeWindow
      .document;
  }

  private getBody() {
    return this.getDocument().body;
  }

  private addClassBody(className) {
    this.getBody().classList.add(className);
  }

  private removeClassBody(className) {
    this.getBody().classList.remove(className);
  }

  lockScroll() {
    this.addClassBody('lock-scroll');
  }

  unlockScroll() {
    this.removeClassBody('lock-scroll');
  }

  mobile() {
    return {
      lockScroll: () => {
        this.addClassBody('mobile-lock-scroll');
      },
      unlockScroll: () => {
        this.removeClassBody('mobile-lock-scroll');
      },
    };
  }
}
